import CommonSelectPanel from './src/common-select-panel';

export default CommonSelectPanel;
